<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M28.75 20H23.75C23.0596 20 22.5 20.5596 22.5 21.25V31.25C22.5 31.9404 23.0596 32.5 23.75 32.5H28.75C30.1307 32.5 31.25 31.3807 31.25 30V22.5C31.25 21.1193 30.1307 20 28.75 20ZM28.75 30H25V22.5H28.75V30Z"
      fill="white"
    />
    <path
      d="M40 22.5V20H33.75C33.0596 20 32.5 20.5596 32.5 21.25V32.5H35V27.5H40V25H35V22.5H40Z"
      fill="white"
    />
    <path
      d="M2.5 36.25V3.75002C2.5 3.05963 3.05961 2.50002 3.75 2.50002H22.5V7.50002C22.5 8.88072 23.6193 10 25 10H30V13.75H32.5V8.75002C32.5019 8.41775 32.3715 8.09838 32.1375 7.86252L24.6375 0.36252C24.4016 0.128535 24.0823 -0.00185505 23.75 1.99452e-05H3.75C1.67891 1.99452e-05 0 1.679 0 3.75002V36.25C0 38.3211 1.67891 40 3.75 40H12.5V37.5H3.75C3.05969 37.5 2.5 36.9404 2.5 36.25Z"
      fill="white"
    />
    <path
      d="M18.75 20H13.75C13.0596 20 12.5 20.5596 12.5 21.25V32.5H15V28.75H18.75C20.1307 28.75 21.25 27.6307 21.25 26.25V22.5C21.25 21.1193 20.1307 20 18.75 20ZM18.75 26.25H15V22.5H18.75V26.25Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: 'PdfFile',
}
</script>

<style scoped></style>
